(() => {
  const copy = {
    bagLabel: document.body.dataset.cartBagLabel || 'Bag',
    productLabel: document.body.dataset.cartProductLabel || 'Fruit Rolls',
    removeLabel: document.body.dataset.cartRemoveLabel || 'Remove',
    emptyTitle: document.body.dataset.cartEmptyTitle || 'Your bag is empty.',
    emptyCopy: document.body.dataset.cartEmptyCopy || 'The orchard is ready when you are.',
    emptyLinkLabel: document.body.dataset.cartEmptyLinkLabel || 'Shop fruit rolls',
    emptyLinkUrl: document.body.dataset.cartEmptyLinkUrl || '/collections/all',
    addedMessage: document.body.dataset.cartAddedMessage || 'Item added to your bag.',
    addedButtonLabel: document.body.dataset.cartAddedButtonLabel || 'Added to bag',
    addErrorMessage: document.body.dataset.cartAddErrorMessage || 'This item could not be added. Please try again.',
    updateMessage: document.body.dataset.cartUpdateMessage || 'Bag quantity updated.',
    removedMessage: document.body.dataset.cartRemovedMessage || 'Item removed from your bag.',
    updateErrorMessage: document.body.dataset.cartUpdateErrorMessage || 'Your bag could not be updated. Please try again.',
    loadErrorMessage: document.body.dataset.cartLoadErrorMessage || 'We could not load your bag. Please try again.',
  };
  const shell = document.querySelector('[data-cart-shell]');
  const drawer = document.querySelector('.sf-cart-drawer');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerFooter = document.querySelector('[data-cart-drawer-footer]');
  const status = document.querySelector('[data-cart-status]');
  const siteHeader = document.querySelector('[data-site-header]');
  // Keep sticky product media below the actual header, including translated labels.
  if (siteHeader) {
    const updateHeaderHeight = () => document.documentElement.style.setProperty('--sf-header-height', `${siteHeader.getBoundingClientRect().height}px`);
    updateHeaderHeight();
    new ResizeObserver(updateHeaderHeight).observe(siteHeader);
  }
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const siteNavigation = document.querySelector('[data-site-navigation]');
  let returnFocus = null;
  let closeTimer = null;

  // Site-level orchard audio belongs to the shared header, never a carousel.
  const orchardAudio = document.querySelector('[data-site-audio]');
  const soundButton = document.querySelector('[data-site-sound]');
  const soundLabel = document.querySelector('[data-site-sound-label]');
  const soundStatus = document.querySelector('[data-site-sound-status]');
  let soundRequested = false;
  let soundStarting = false;
  let soundNeedsGesture = false;
  let soundPageHidden = false;
  let soundResumePosition = null;
  const soundStorageKey = 'sahrawi:orchard-audio:v1';
  const readSoundPreference = () => {
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(soundStorageKey));
      if (!saved || typeof saved.enabled !== 'boolean') return;
      soundRequested = saved.enabled;
      soundResumePosition = Number.isFinite(saved.position) && saved.position >= 0 ? saved.position : null;
    } catch { /* Storage may be unavailable; the current page still works. */ }
  };
  const saveSoundPreference = () => {
    try {
      window.sessionStorage.setItem(soundStorageKey, JSON.stringify({ enabled: soundRequested,
        position: soundResumePosition ?? (Number.isFinite(orchardAudio?.currentTime) ? orchardAudio.currentTime : 0) }));
    } catch { /* Never make storage permission a prerequisite for sound. */ }
  };
  const restoreSoundPosition = () => {
    if (!orchardAudio || soundResumePosition === null || !Number.isFinite(orchardAudio.duration) || orchardAudio.duration <= 0) return;
    try {
      orchardAudio.currentTime = soundResumePosition % orchardAudio.duration;
      soundResumePosition = null;
    } catch { /* Retry once metadata is available. */ }
  };
  readSoundPreference();
  if (orchardAudio) orchardAudio.loop = true;
  const updateSound = () => {
    const playing = Boolean(orchardAudio && !orchardAudio.paused);
    soundButton?.setAttribute('aria-pressed', String(playing));
    soundButton?.setAttribute('aria-label', playing ? 'Pause orchard sounds' : soundNeedsGesture ? 'Resume orchard sounds' : 'Play orchard sounds');
    if (soundLabel) soundLabel.textContent = playing ? 'Sound on' : soundNeedsGesture ? 'Resume sound' : 'Sound off';
  };
  const playOrchard = async () => {
    if (!orchardAudio || soundStarting || document.hidden || soundPageHidden) return;
    soundStarting = true;
    soundNeedsGesture = false;
    restoreSoundPosition();
    try {
      await orchardAudio.play();
      // A pause/visibility change may happen while the play promise is pending.
      if (!soundRequested || document.hidden || soundPageHidden) orchardAudio.pause();
      if (soundStatus) soundStatus.textContent = '';
    } catch {
      // Browser autoplay policy must not erase the visitor's saved choice.
      if (soundRequested && !document.hidden && !soundPageHidden) {
        soundNeedsGesture = true;
        if (soundStatus) soundStatus.textContent = 'Tap Resume sound to continue orchard sounds.';
      }
    } finally {
      soundStarting = false;
    }
    updateSound();
  };
  soundButton?.addEventListener('click', () => {
    if (!orchardAudio) return;
    soundRequested = !(soundRequested && (!orchardAudio.paused || soundStarting));
    soundNeedsGesture = false;
    saveSoundPreference();
    if (soundRequested) void playOrchard();
    else orchardAudio.pause();
    updateSound();
  });
  orchardAudio?.addEventListener('play', updateSound);
  orchardAudio?.addEventListener('pause', updateSound);
  orchardAudio?.addEventListener('loadedmetadata', restoreSoundPosition);
  orchardAudio?.addEventListener('ended', () => {
    if (soundRequested && !document.hidden) {
      orchardAudio.currentTime = 0;
      void playOrchard();
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { saveSoundPreference(); orchardAudio?.pause(); }
    else if (soundRequested && !soundNeedsGesture) void playOrchard();
  });
  window.addEventListener('pagehide', () => {
    soundPageHidden = true;
    saveSoundPreference();
    orchardAudio?.pause();
  });
  window.addEventListener('pageshow', (event) => {
    soundPageHidden = false;
    if (event.persisted) { readSoundPreference(); soundNeedsGesture = false; }
    if (soundRequested && !document.hidden && !soundNeedsGesture) void playOrchard();
    else if (!soundRequested) orchardAudio?.pause();
    updateSound();
  });
  updateSound();
  if (soundRequested && !document.hidden) void playOrchard();

  const closeMenu = () => {
    window.clearTimeout(menuHoverTimer);
    menuPinned = false;
    siteHeader?.classList.remove('is-menu-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    if (siteNavigation) siteNavigation.hidden = true;
  };
  let menuHoverTimer;
  let menuPinned = false;
  const desktopMenu = window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
  const openMenu = (pin = false) => {
    if (!siteNavigation || !menuToggle) return;
    window.clearTimeout(menuHoverTimer);
    menuPinned = pin || menuPinned;
    siteHeader?.classList.add('is-menu-open');
    siteNavigation.hidden = false;
    menuToggle.setAttribute('aria-expanded', 'true');
  };
  if (menuToggle) menuToggle.hidden = false;
  menuToggle?.addEventListener('click', () => {
    if (menuPinned && !siteNavigation?.hidden) closeMenu();
    else openMenu(true);
  });
  menuToggle?.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    openMenu(true);
    siteNavigation?.querySelector('a[href]')?.focus();
  });
  menuToggle?.addEventListener('pointerenter', (event) => {
    if (!desktopMenu.matches || event.pointerType !== 'mouse') return;
    window.clearTimeout(menuHoverTimer);
    menuHoverTimer = window.setTimeout(() => openMenu(), 120);
  });
  menuToggle?.addEventListener('pointerleave', () => {
    window.clearTimeout(menuHoverTimer);
    if (desktopMenu.matches && !menuPinned) menuHoverTimer = window.setTimeout(() => {
      if (!siteNavigation?.contains(document.activeElement)) closeMenu();
    }, 180);
  });
  siteNavigation?.addEventListener('pointerenter', () => window.clearTimeout(menuHoverTimer));
  siteNavigation?.addEventListener('pointerleave', () => {
    if (desktopMenu.matches && !menuPinned) menuHoverTimer = window.setTimeout(() => {
      if (!siteNavigation.contains(document.activeElement)) closeMenu();
    }, 180);
  });
  siteNavigation?.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });
  document.addEventListener('pointerdown', (event) => {
    if (!siteNavigation?.contains(event.target) && !menuToggle?.contains(event.target)) closeMenu();
  });
  siteHeader?.addEventListener('focusout', () => window.setTimeout(() => {
    if (!siteNavigation?.contains(document.activeElement) && !menuToggle?.contains(document.activeElement)) closeMenu();
  }, 0));
  window.matchMedia('(max-width: 900px)').addEventListener('change', () => {
    if (siteNavigation?.contains(document.activeElement)) menuToggle?.focus();
    closeMenu();
  });

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);

  const money = (cents) => new Intl.NumberFormat('en-EG', {
    style: 'currency', currency: 'EGP', maximumFractionDigits: 0
  }).format(Number(cents || 0) / 100).replace('EGP', 'EGP ');

  const announce = (message) => {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(() => { status.textContent = message; }, 20);
  };

  const request = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(options.headers || {}) },
      ...options
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };

  const setCounts = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = count; });
    document.querySelectorAll('.d17-head__bag[data-cart-toggle]').forEach((node) => {
      node.textContent = `${copy.bagLabel} · ${count}`;
      node.setAttribute('aria-label', `Open bag, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  };

  const renderCart = (cart) => {
    setCounts(cart.item_count);
    if (!drawerBody || !drawerFooter) return;
    if (!cart.item_count) {
      drawerBody.innerHTML = `<div class="sf-empty-state"><h2>${escapeHtml(copy.emptyTitle)}</h2><p>${escapeHtml(copy.emptyCopy)}</p><a class="sf-primary-button" href="${escapeHtml(copy.emptyLinkUrl)}">${escapeHtml(copy.emptyLinkLabel)}</a></div>`;
      drawerFooter.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map((item) => {
      const itemUrl = item.url || `/products/${item.handle}`;
      const imageUrl = item.featured_image?.url || item.image || '';
      const descriptor = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `
      <article class="sf-drawer-line">
        <a class="sf-drawer-line__image" href="${escapeHtml(itemUrl)}" aria-label="View ${escapeHtml(item.product_title)}">${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="" width="152" height="152">` : ''}</a>
        <div>
          <a class="sf-eyebrow sf-cart-product-label" href="${escapeHtml(itemUrl)}">${escapeHtml(item.product_type || copy.productLabel)}</a>
          <h3><a href="${escapeHtml(itemUrl)}">${escapeHtml(item.product_title)}</a></h3>
          ${descriptor ? `<p>${escapeHtml(descriptor)}</p>` : ''}
          <div class="sf-drawer-line__actions">
            <div class="sf-quantity-stepper" aria-label="Quantity for ${escapeHtml(item.product_title)}">
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <strong aria-live="polite">${item.quantity}</strong>
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button class="sf-secondary-link" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="${escapeHtml(copy.removeLabel)} ${escapeHtml(item.product_title)} from bag">${escapeHtml(copy.removeLabel)}</button>
          </div>
          <strong class="sf-drawer-line__price">${money(item.final_line_price)}</strong>
        </div>
      </article>`;
    }).join('');
    drawerFooter.hidden = false;
    const total = drawerFooter.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  };

  const renderCartPage = (cart) => {
    if (!document.body.classList.contains('sf-page--cart')) return;
    if (!cart.item_count) { window.location.reload(); return; }
    const items = new Map(cart.items.map((item) => [item.key, item]));
    document.querySelectorAll('[data-cart-page-line]').forEach((line) => {
      const item = items.get(line.dataset.lineKey);
      if (!item) { line.remove(); return; }
      const quantity = line.querySelector('[data-cart-page-quantity]');
      const linePrice = line.querySelector('[data-cart-page-line-price]');
      const buttons = line.querySelectorAll('.sf-quantity-stepper [data-cart-change]');
      if (quantity) quantity.textContent = item.quantity;
      if (linePrice) linePrice.textContent = money(item.final_line_price);
      if (buttons[0]) buttons[0].dataset.quantity = Math.max(0, item.quantity - 1);
      if (buttons[buttons.length - 1]) buttons[buttons.length - 1].dataset.quantity = item.quantity + 1;
    });
    const total = document.querySelector('[data-cart-page-total]');
    if (total) total.textContent = money(cart.total_price);
    setCounts(cart.item_count);
  };

  const getCart = () => request('/cart.js');

  const openDrawer = async (trigger) => {
    if (!shell || !drawer) return;
    returnFocus = trigger || document.activeElement;
    window.clearTimeout(closeTimer);
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => shell.classList.add('is-open'));
    document.body.classList.add('sf-cart-open');
    document.querySelectorAll('[data-cart-toggle]').forEach((node) => node.setAttribute('aria-expanded', 'true'));
    drawer.setAttribute('aria-busy', 'true');
    try { renderCart(await getCart()); }
    catch (error) { drawerBody.innerHTML = `<p>${escapeHtml(copy.loadErrorMessage)}</p>`; }
    finally { drawer.removeAttribute('aria-busy'); drawer.focus(); }
  };

  const closeDrawer = () => {
    if (!shell) return;
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sf-cart-open');
    document.querySelectorAll('[data-cart-toggle]').forEach((node) => node.setAttribute('aria-expanded', 'false'));
    closeTimer = window.setTimeout(() => { shell.hidden = true; }, 340);
    if (returnFocus instanceof HTMLElement) returnFocus.focus();
  };

  const buttonConfirmations = new WeakMap();
  const resetConfirmation = (button) => buttonConfirmations.get(button)?.();
  const confirmAddition = (button) => {
    const label = button.querySelector('[data-add-to-bag-copy]') || button;
    const original = label.textContent;
    const originalAriaLabel = button.getAttribute('aria-label');
    button.dataset.cartAdded = '';
    label.textContent = copy.addedButtonLabel;
    if (originalAriaLabel !== null) button.setAttribute('aria-label', copy.addedButtonLabel);
    const timer = window.setTimeout(() => resetConfirmation(button), 2000);
    buttonConfirmations.set(button, () => {
      window.clearTimeout(timer);
      delete button.dataset.cartAdded;
      label.textContent = original;
      if (originalAriaLabel !== null) button.setAttribute('aria-label', originalAriaLabel);
      buttonConfirmations.delete(button);
    });
  };
  const additionAnimations = new WeakMap();
  const animateAddition = (button) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    [button, ...document.querySelectorAll('[data-cart-toggle]')].forEach((node) => {
      if (!node.animate) return;
      additionAnimations.get(node)?.cancel();
      // A short, diminishing bell-like rotation, without moving the layout.
      const angle = node === button ? 2 : 7;
      const animation = node.animate([0, -1, 1, -.7, .7, -.3, .3, 0].map((amount) => ({
        transform: `rotate(${amount * angle}deg)`, transformOrigin: '50% 25%',
      })), { duration: 460, easing: 'ease-in-out' });
      additionAnimations.set(node, animation);
      animation.onfinish = () => additionAnimations.delete(node);
    });
  };
  const showAddError = (form, message) => {
    let error = form.querySelector('[data-cart-add-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'sf-cart-add-error';
      error.dataset.cartAddError = '';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.textContent = message;
    error.hidden = false;
  };

  // Serialize adds so separate product buttons cannot race the bag count.
  let addQueue = Promise.resolve();
  const addForm = async (form, button) => {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    resetConfirmation(button);
    const previousError = form.querySelector('[data-cart-add-error]');
    if (previousError) previousError.hidden = true;
    const formData = new FormData(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const operation = addQueue.then(async () => {
        await request('/cart/add.js', { method: 'POST', body: formData });
        confirmAddition(button);
        announce(copy.addedMessage);
        // A failed refresh must not tell customers an already-successful add failed.
        try { renderCart(await getCart()); }
        catch {
          try { renderCart(await getCart()); }
          catch { showAddError(form, `${copy.addedMessage} ${copy.loadErrorMessage}`); }
        }
        animateAddition(button);
      });
      addQueue = operation.catch(() => {});
      await operation;
    } catch (error) {
      showAddError(form, copy.addErrorMessage);
    } finally {
      const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      button.disabled = selected ? selected.dataset.available !== 'true' : false;
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form], .sf21-buy-form, .sf-product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) addForm(form, button);
  });

  const updateProductQuantity = (stepper, delta = 0) => {
    const input = stepper.querySelector('input[name="quantity"]');
    const minimum = Number(input.min) || 1;
    const maximum = input.max ? Number(input.max) : Infinity;
    const value = Number.isFinite(input.valueAsNumber) ? Math.trunc(input.valueAsNumber) : minimum;
    input.value = String(Math.max(minimum, Math.min(maximum, value + delta)));
    stepper.querySelectorAll('[data-product-quantity-step]').forEach(button => {
      button.hidden = false;
      button.disabled = Number(button.dataset.productQuantityStep) < 0 ? Number(input.value) <= minimum : Number(input.value) >= maximum;
    });
  };
  const initializeProductQuantities = () => document.querySelectorAll('[data-product-quantity]').forEach(stepper => updateProductQuantity(stepper));
  initializeProductQuantities();
  document.addEventListener('shopify:section:load', initializeProductQuantities);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-quantity-step]');
    if (!button) return;
    const stepper = button.closest('[data-product-quantity]');
    updateProductQuantity(stepper, Number(button.dataset.productQuantityStep));
    stepper.querySelector('input').dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (event) => {
    const stepper = event.target.closest('[data-product-quantity]');
    if (stepper) updateProductQuantity(stepper);
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const form = select.closest('[data-product-form]');
    const button = form?.querySelector('[data-add-to-bag]');
    const copyNode = button?.querySelector('[data-add-to-bag-copy]');
    const option = select.selectedOptions[0];
    if (!button || !copyNode || !option) return;
    resetConfirmation(button);
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    copyNode.textContent = available
      ? `${option.dataset.price} · ${button.dataset.addLabel}`
      : button.dataset.soldOutLabel;
  });

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (toggle) { event.preventDefault(); openDrawer(toggle); return; }
    if (event.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const change = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (!change) return;
    const key = change.dataset.cartChange || change.dataset.cartRemove;
    const quantity = Number(change.dataset.quantity || 0);
    change.disabled = true;
    try {
      const cart = await request('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
      });
      renderCartPage(cart);
      renderCart(cart);
      announce(quantity ? copy.updateMessage : copy.removedMessage);
    } catch (error) { announce(copy.updateErrorMessage); }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && siteHeader?.classList.contains('is-menu-open')) {
      closeMenu();
      menuToggle?.focus();
      return;
    }
    if (!shell || shell.hidden) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab' || !drawer) return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  getCart().then(renderCart).catch(() => {});
})();
